import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";

import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import Collapse from "@mui/material/Collapse";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import UiSearch from "../../../_uiComponents/common/form/UiSearch";
import { UiButton } from "../../../_uiComponents/common/form/UiButton";
import { Context } from "../../../../_context/Store";
import UiModal from "../../../_uiComponents/common/UiModal";
import {
     DragAndDrop,
     Drag,
     Drop,
} from "../../../_uiComponents/common/drag-and-drop";
import {
     dataTemplateDeleteJsonSchemaRequest,
     dataTemplateSchemaValueGetRequest,
     dataTemplateSchemaValueReOrderRequest,
     dataTemplateValueDeleteRequest,
} from "../../../../_redux/_actions";
import { contextApiActions, dataTemplateConstants } from "../../../../_redux/_constants";
import DataTemplatesAddRowForm from "../forms/DataTemplatesAddRowForm";
import { FORM_TYPE_ADD, FORM_TYPE_EDIT } from "../../../../_helpers/constants";
import { dataTemplatesTableConfig } from "../module.config";
import {
     UiGridType,
     ApprovedIcon,
     NotApprovedIcon,
} from "../../../_uiComponents/common/DataGridComponents";

export default function DataTemplatesRowManagement(props) {
     const [state, dispatch] = useContext(Context);

     const actionDispatch = useDispatch();

     const { rowValueList, dataTableList} = useSelector((state) => {
          return {
               rowValueList: state.dataTemplate.tableValueList.data,
               totalRecords: state.factTable.tableValueList.totalRecords,
               dataTableList: state.dataTemplate.list.data,
          };
     });



     const addValueFormOpen = () => {
          dispatch({
               type: contextApiActions.UI_MODAL_TOGGEL,
               payload: {
                    show: true,
                    heading: "Add Column",
                    children: (
                         <DataTemplatesAddRowForm
                              tableId={props.tableId}
                              type={FORM_TYPE_ADD}
                         />
                    ),
               },
          });
     };

     const editValueFormOpen = (id) => {
          actionDispatch(
               dataTemplateSchemaValueGetRequest({
                    id,
               }),
          );

          dispatch({
               type: contextApiActions.UI_MODAL_TOGGEL,
               payload: {
                    show: true,
                    heading: "Update Schema",
                    children: (
                         <DataTemplatesAddRowForm
                              tableId={props.tableId}
                              id={id}
                              type={FORM_TYPE_EDIT}
                         />
                    ),
               },
          });
     };

     const deleteFactTableValue = (id) => {
          dispatch({
               type: contextApiActions.UI_CONFIRMATION_TOGGEL,
               payload: {
                    show: true,
                    okFunction: () =>
                         actionDispatch(
                              dataTemplateDeleteJsonSchemaRequest({
                                   id:id,
                                   dataTableId:props.tableId,
                                   page:props.page,
                                   pageSize:props.pageSize
                              }),
                         ),
               },
          });
     };

     const tableSchemaValueReOrder = (result) => {
          if (!result.destination) return;

          const itemsCopy = Array.from(rowValueList);
          const [reorderedItem] = itemsCopy.splice(result.source.index, 1);
          itemsCopy.splice(result.destination.index, 0, reorderedItem);

          const attributeList = itemsCopy.map((item, index) => {
               return {
                    dataTemplateSchemaId: item.id,
                    order: index + 1,
               };
          });

          actionDispatch(
               dataTemplateSchemaValueReOrderRequest({
                    dataTemplateId: props.tableId,
                    attributeList: attributeList,
               }),
          );
     };


     const dataTemplateType = dataTableList.filter(datalist => datalist.id === props.tableId);
     const Types = (dataTemplateType[0]?.dataTemplateType === dataTemplateConstants.PARTICIPANT ? 3 : 4);

     return (
          <Box sx={{ margin: 1 }}>
               <h2 className="sba-create-fact-table-heading">
                    {`Manage ${dataTemplateType[0]?.dataTemplateType} Data`}
               </h2>
               <div className="sba-subtable-top-btns">
                    <div className="sba-add-row-button">
                         <Button
                              variant="contained"
                              startIcon={<AddIcon />}
                              onClick={addValueFormOpen}
                         >
                              Add Column
                         </Button>
                         <Button
                              onClick={() => {
                                   // TODO need to do in proper way with configurations

                                   const link =
                                        document.createElement(
                                             "a",
                                        );
                                   link.href =
                                        `https://as-sherbet-api-incentive-dev.azurewebsites.net/v1/DataFileProcessing/GetDataSchemaTemplate/${Types}/${props.tableId}`
                                   document.body.appendChild(
                                        link,
                                   );
                                   link.click();
                                   document.body.removeChild(
                                        link,
                                   );
                              }}
                              // size="small"
                              sx={{ml:1}}
                              variant="contained"
                         >
                              Download Template
                         </Button>
                    </div>

                    <div className="sba-subtable-search">
                         <UiSearch onChange={props.getTableRowValueList} />
                    </div>
               </div>
               <div className="sba-sub-table sba-fact-table-drag">
                    <Table size="small" aria-label="purchases">
                         <TableHead>
                              <TableRow>
                                   <TableCell></TableCell>
                                   {dataTemplatesTableConfig.schemaList.tableMapper.map(
                                        (column) => {
                                             return column.isShow ? (
                                                  <TableCell align={column.align}>
                                                       {column.name}
                                                  </TableCell>
                                             ) : null;
                                        },
                                   )}

                                   <TableCell></TableCell>
                              </TableRow>
                         </TableHead>

                         <DragAndDrop
                              onDragEnd={(data) =>
                                   tableSchemaValueReOrder(data)
                              }
                         >
                              {rowValueList.map((row, index) => {
                                   return (
                                        <Drop
                                             key={row.id}
                                             id={row.id + "dddd"}
                                             type="droppable-item"
                                        >
                                             <Drag
                                                  className="draggable"
                                                  key={row.id}
                                                  id={row.id + "dddd"}
                                                  index={index}
                                             >
                                                  {dataTemplatesTableConfig.schemaList.tableMapper.map(
                                                       (
                                                            headCell,
                                                            indexCell,
                                                       ) => {
                                                            return (
                                                                 headCell.isShow && (
                                                                      <>
                                                                           {headCell.type ==
                                                                                "text" ? (
                                                                                <TableCell>
                                                                                     {/* {
                                                                                          row[
                                                                                          headCell
                                                                                               .id
                                                                                          ]
                                                                                     } */}
                                                                                     {headCell.id == "name" &&
                                                                                          <>{row?.schemaDataTypeName === dataTemplateConstants.FACT_TABLE ? row?.factTableName : row.name}</>
                                                                                     }
                                                                                     {headCell.id == "type" &&
                                                                                          <UiGridType name={`${row.schemaDataTypeName} ${row?.lookupTableName !== null ? ` - ${row?.lookupTableName}` : ""}`} />
                                                                                     }
                                                                                     {headCell.id == "identity" && (
                                                                                          row.identifier ? <div className="sba-ft-align-cell"> <ApprovedIcon /> </div>: <>   </>
                                                                                     )}

                                                                                     {headCell.id == "required" && (
                                                                                          row.required ? <div className="sba-ft-align-cell"> <ApprovedIcon /> </div>: <div className="sba-ft-align-cell"><NotApprovedIcon /> </div>
                                                                                     )}

                                                                                     {headCell.id == "filterable" && (
                                                                                          row.filterable ? <div className="sba-ft-align-cell"> <ApprovedIcon /> </div>: <div className="sba-ft-align-cell"><NotApprovedIcon /></div>
                                                                                     )}
                                                                                </TableCell>
                                                                           ) : (


                                                                                <TableCell>
                                                                                     <Stack
                                                                                          direction="row"
                                                                                          spacing={
                                                                                               1
                                                                                          }
                                                                                     >
                                                                                          <>
                                                                                               {headCell.id ==
                                                                                                    "attribute" &&
                                                                                                    row[
                                                                                                    headCell
                                                                                                         .id
                                                                                                    ] && (
                                                                                                         <UiGridType name={
                                                                                                              row[
                                                                                                                   headCell
                                                                                                                        .id
                                                                                                              ]
                                                                                                                   .name
                                                                                                         } />



                                                                                                    )}
                                                                                          </>
                                                                                     </Stack>
                                                                                </TableCell>

                                                                           )}
                                                                      </>
                                                                 )
                                                            );
                                                       },
                                                  )}
                                                  <TableCell align="right">
                                                       <div className="sbt-data-grid__action-bar">
                                                            <Tooltip
                                                                 title="Edit"
                                                                 placement="top"
                                                                 arrow
                                                            >
                                                                 <IconButton
                                                                      onClick={() =>
                                                                           editValueFormOpen(
                                                                                row.id,
                                                                           )
                                                                      }
                                                                      aria-label="Edit"
                                                                      sx={{
                                                                           ml: 1.5,
                                                                      }}
                                                                 >
                                                                      <EditIcon />
                                                                 </IconButton>
                                                            </Tooltip>
                                                            <Tooltip
                                                                 title="Delete"
                                                                 placement="top"
                                                                 arrow
                                                            >
                                                                 <IconButton
                                                                      onClick={() =>
                                                                           deleteFactTableValue(
                                                                                row.id,
                                                                           )
                                                                      }
                                                                      aria-label="Delete"
                                                                      sx={{
                                                                           ml: 0.5,
                                                                      }}
                                                                 >
                                                                      <DeleteIcon color="error" />
                                                                 </IconButton>
                                                            </Tooltip>
                                                       </div>
                                                  </TableCell>
                                             </Drag>
                                        </Drop>
                                   );
                              })}
                              {/* <Drop key={"e"} id={"e"} type="droppable-item">
                                   <Drag
                                        className="draggable"
                                        key={"d"}
                                        id={"d"}
                                        index={123}
                                   >
                                        <TableCell>date</TableCell>
                                        <TableCell>custom</TableCell>
                                        <TableCell>
                                             <Stack direction="row" spacing={1}>
                                                  <Chip label={"custom"} />
                                                  <Chip label={"custom"} />
                                                  <Chip label={"custom"} />
                                                  <Chip label={"custom"} />
                                             </Stack>
                                        </TableCell>
                                        <TableCell align="right">
                                             <div className="sbt-data-grid__action-bar">
                                                  <Tooltip
                                                       title="Edit"
                                                       placement="top"
                                                       arrow
                                                  >
                                                       <IconButton
                                                            aria-label="Edit"
                                                            sx={{
                                                                 ml: 1.5,
                                                            }}
                                                       >
                                                            <EditIcon />
                                                       </IconButton>
                                                  </Tooltip>
                                                  <Tooltip
                                                       title="Delete"
                                                       placement="top"
                                                       arrow
                                                  >
                                                       <IconButton
                                                            aria-label="Delete"
                                                            sx={{
                                                                 ml: 0.5,
                                                            }}
                                                       >
                                                            <DeleteIcon color="error" />
                                                       </IconButton>
                                                  </Tooltip>
                                             </div>
                                        </TableCell>
                                   </Drag>
                              </Drop> */}
                         </DragAndDrop>
                    </Table>
               </div>
          </Box>
     );
}
